import { useState, useEffect } from 'react';
import { projectFirestore } from '../firebase';
import { useAuth } from '../contexts/AuthContext';

const useDocs = (collection, updated) => {
  const { currentUser } = useAuth();
  const [docs, setDocs] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!currentUser) {
      setDocs(null);
      setLoading(false);
      return;
    }

    let cancelled = false;

    async function fetchDoc() {
      setLoading(true);
      setError(null);

      try {
        const snapshot = await projectFirestore
          .collection(collection)
          .doc(currentUser.uid)
          .get();

        if (cancelled) return;

        let profileData = snapshot.exists ? snapshot.data() : {};

        if (!profileData.username) {
          const usernameSnap = await projectFirestore
            .collection('usernames')
            .where('uid', '==', currentUser.uid)
            .limit(1)
            .get();

          if (cancelled) return;

          if (!usernameSnap.empty) {
            profileData = {
              ...profileData,
              username: usernameSnap.docs[0].id,
            };
          }
        }

        setDocs(profileData);
      } catch (err) {
        if (cancelled) return;
        console.error('useDocs:', err);
        setError(err.message || 'Failed to load data');
        setDocs(null);
      } finally {
        if (!cancelled) setLoading(false);
      }
    }

    fetchDoc();

    return () => {
      cancelled = true;
    };
  }, [collection, updated, currentUser]);

  return { docs: docs || {}, loading, error };
};

export default useDocs;
